import { empresaDataInterface } from "../../pages/Empresa/empresa";

export const esportzyData: empresaDataInterface = {
    "color": "rgba(0, 211, 137, 1)",
    "link": "/esportzy",
    "icon":"https://media.grupoinveste.pt/emp/esportzy/icon.png",
    "logo_white":"https://media.grupoinveste.pt/emp/esportzy/horizontal_white.png",
    "header": {
        "website": "https://esportzy.pt",
        "banner": "https://media.grupoinveste.pt/emp/esportzy/banner.jpg",
        "tags": [
            "esportzy.tags.0", "esportzy.tags.1", "esportzy.tags.2",
        ],
        "name": "esportzy.name",
        "slogan": "esportzy.slogan"
    },
    "section1": {
        "img": "https://media.grupoinveste.pt/emp/esportzy/horizontal_black.png",
        "title_1": "esportzy.section1.title1",
        "text_1": "esportzy.section1.text1",
        "text_2": "esportzy.section1.text2",
        "title_2": "esportzy.section1.title2",
        "text_3": "esportzy.section1.text3",
        "text_4": "esportzy.section1.text4",
    },
    "section2": [
        {
            "title": "esportzy.section2.0.title",
            "text": [
                "esportzy.section2.0.text.0", "esportzy.section2.0.text.1", "esportzy.section2.0.text.2"
            ]
        },
        {
            "title": "esportzy.section2.1.title",
            "text": [
                "esportzy.section2.1.text.0", "esportzy.section2.1.text.1", "esportzy.section2.1.text.2", "esportzy.section2.1.text.3"
            ]
        },
        {
            "title": "esportzy.section2.2.title",
            "text": [
                "esportzy.section2.2.text.0", "esportzy.section2.2.text.1", "esportzy.section2.2.text.2", "esportzy.section2.2.text.3"
            ]
        }
    ],
    "section3": {
        "title": "esportzy.section3.title",
        "text": "esportzy.section3.text",
        "link": "https://www.invest2030.pt/meeting"
    }
}